import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { Button, Card, CardBody, Container, Form, FormGroup, Label } from 'reactstrap';
import { InputField } from 'src/components';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import DeleteInformationModal from 'src/components/DeleteInformation/DeleteInformationModal';
import { useGetFcpsCourseListsForLogbookEntryMutation, useLazyGetFormByLogbookTypeAndSubjectQuery } from 'src/rtk/features/setup/logBookEntrySetupDetails/logBookEntrySetupDetailsApi';
import { useDeleteLogbookEntrySetupMasterMutation, useLazyGetCaseTypeFormListQuery } from 'src/rtk/features/setup/logBookEntrySetupMaster/logBookEntrySetupMasterApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';


interface QueryParams {
  id?: number;
  course_type?: string;
  subject_id?: string;
  main_training?: string;
}

const initialValues: LogbookEntrySetupMaster = {
  id: '',
  setup_logbook_master_id: '',
  logbook_entry_setup_master_id: '',
  particulars: '',
  details: '',
  note: '',
  help: '',
  is_show_ind: 1,
  sl_no: 0,
  particulary_type: 1,
  course_type: '',
  target_minimum: 0,
  target_maximum: 0,
  status: true,
  creator_organization_id: '',
  updater_organization_id: '',
  created_by: '',
  updated_by: '',
  deleted_by: '',
  created_at: '',
  updated_at: '',
  deleted_at: '',
};


export const LogbookEntrySetupMasters = () => {
  const history = useHistory();

  const [getForms, { data: formSetups, isSuccess: isFormSetupsSuccess, isLoading: isFormSetupsLoading, isFetching: isFormSetupsFetching }] =
    useLazyGetFormByLogbookTypeAndSubjectQuery();

  const [createFcpsCourse, { data: fcpsCourseListData, isSuccess: isFcpsCourseListSuccess, isError: isFcpsCourseListError, error: fcpsCourseListError }] =
    useGetFcpsCourseListsForLogbookEntryMutation();

  const { data: getSubjectInfolist } = useGetSubjectInfosQuery();
  const subjects = getSubjectInfolist?.data;

  const [showStatus, setShowStatus] = useState<boolean>(true);
  const [subject, setSubject] = useState<SubjectInfo>(
    {} as SubjectInfo
  );
  const [queryParams, setQueryParams] = useState<QueryParams>(
    {} as QueryParams,
  );
  const [selectedSubject, setSelectedSubject] = useState<any>('');
  const [selectedType, setSelectedType] = useState<any>('');

  const [mainTrainings, setMainTrainings] = useState<FcpsCourseList[]>([]);
  const [forms, setForms] = useState<LogbookEntrySetupMaster[]>([]);
  const [selectedForm, setSelectedForm] = useState<LogbookEntrySetupMaster | null>(null);
  const [selectedCaseTypeObject, setSelectedCaseTypeObject] = useState<LogbookEntrySetupMaster | null>(null);
  const [coreAdvanceOptions, setCoreAdvanceOptions] = useState<SelectOption[]>([]);

  // New state for entry type and case type
  const [entryType, setEntryType] = useState<string>(''); // 'case' or 'skill'
  const [caseTypes, setCaseTypes] = useState<any[]>([]);
  const [selectedCaseType, setSelectedCaseType] = useState<string>('');
  const [modalShow, setModalShow] = useState(false);

  const [deleteRowId, setDeleteRowId] = useState<string>('');

  const [getCaseTypeFormList, { data, error, isLoading, isError }] = useLazyGetCaseTypeFormListQuery();

  const [deleteLogbookEntrySetupMaster, { isSuccess: isDeleteSuccess, isLoading: isDeleteLoading, isError: isDeleteError }] =
    useDeleteLogbookEntrySetupMasterMutation();


  const deleteHandler = (modalState: boolean, id: string) => {
    setModalShow(modalState);
    setDeleteRowId(id);
  };

  useEffect(() => {
    if (isDeleteSuccess) {
      toast.success('Deleted successfully');
    }
    if (isDeleteError) {
      toast.error('Something went wrong');
    }
  }, [isDeleteSuccess, isDeleteError]);
  useEffect(() => {
    if (selectedForm) {
      getCaseTypeFormList(selectedForm?.id!);
    }
  }, [selectedForm]);

  const [mainTraining, setMainTraining] = useState<FcpsCourseList>(
    {} as FcpsCourseList,
  );

  let formOptions: SelectOption[] =
    forms?.map((e: LogbookEntrySetupMaster) => {
      return {
        label: e.particulars!,
        value: e.id!,
      };
    }) ?? [];

  let subjectOptions: SelectOption[] =
    subjects?.map((subject) => ({
      value: subject.id!,
      label: subject.subject_name,
    })) || [];

  let mainTrainingOptions: SelectOption[] =
    mainTrainings?.map((mainTraining) => ({
      value: mainTraining.id!,
      label: mainTraining.name!,
    })) || [];

  let typeOptions: SelectOption[] = [
    {
      label: 'Logbook',
      value: 1,
    },
    {
      label: 'Academic',
      value: 2,
    }
  ];

  const columns: TableColumn<any>[] = [
    {
      name: <div>Sl. No.</div>,
      cell: (row, index) => (
        <div className='badge bg-primary px-2 fw-bold'>{index + 1}</div>
      ),
      width: '80px',
    },

    {
      name: <div>Particulars</div>,
      selector: (row) => row?.particulars,
      sortable: false,
      wrap: true
    },

    {
      name: <div>Skill Type</div>,
      cell: (row: any) => (
        <table className='table table-bordered table-sm'>
          <tbody>
            {row?.entry_setup_master?.map((entry: LogbookEntrySetupMaster, index: number) => (
              <tr key={index}>
                <td>
                  <span className={`${(selectedType?.value === 2 && selectedForm?.particulars?.toLowerCase() === 'academic activity') ? 'text-white bg-black fw-bold fs-5' : ''}`}>{entry.particulars}</span>
                  {(entry?.entry_setup_master && entry?.entry_setup_master?.length > 0) &&
                    <table className='table table-striped table-bordered table-sm'>
                      <tbody>
                        {entry?.entry_setup_master?.map((detail: any, detailIndex: number) => (
                          <tr key={detailIndex} className='ps-3'>
                            <td>
                              {detail.particulars}
                            </td>
                            <td>
                              <i className="fa-solid fa-trash fa-xl" style={{ cursor: 'pointer' }} onClick={() => {
                                deleteHandler(true, detail?.id!)
                              }}></i>

                              {
                                modalShow && deleteRowId === detail?.id ? (
                                  <DeleteInformationModal
                                    isOpen={modalShow}
                                    toggle={() => setModalShow(!modalShow)}
                                    id={deleteRowId}
                                    deleteInfomation={deleteLogbookEntrySetupMaster}
                                  />
                                ) : null
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>}
                </td>
                <td className='align-middle'>
                  <i className="fa-solid fa-trash fa-xl text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                    deleteHandler(true, entry?.id!)
                  }}></i>

                  {
                    modalShow && deleteRowId === entry?.id ? (
                      <DeleteInformationModal
                        isOpen={modalShow}
                        toggle={() => setModalShow(!modalShow)}
                        id={deleteRowId}
                        deleteInfomation={deleteLogbookEntrySetupMaster}
                      />
                    ) : null
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ),
      width: '500px',
      sortable: false,
      wrap: true
    },
    {
      name: <div>Action</div>,
      cell: (row) => (
        <>

          <Button
            className='btn btn-sm btn-danger'
            onClick={() => deleteHandler(true, row?.id!)}
          >
            Delete

          </Button>

          {
            modalShow && deleteRowId === row?.id ? (
              <DeleteInformationModal
                isOpen={modalShow}
                toggle={() => setModalShow(!modalShow)}
                id={deleteRowId}
                deleteInfomation={deleteLogbookEntrySetupMaster}
              />
            ) : null
          }
        </>

      ),
    },
  ];



  console.log(modalShow);
  const { handleSubmit, handleChange, setFieldValue, getFieldProps, values, touched, errors, resetForm, setErrors } =
    useFormik({
      initialValues,

      onSubmit: (values) => {

      },
    });

  useEffect(() => {
    if (subject?.id) {
      createFcpsCourse(subject?.id!);
    }
  }, [subject]);

  useEffect(() => {
    if (isFcpsCourseListSuccess && fcpsCourseListData?.success) {
      const mainTrainings: FcpsCourseList[] = fcpsCourseListData.data;
      setMainTrainings(mainTrainings);
    } else {
      setMainTrainings([]);
    }
  }, [isFcpsCourseListSuccess, fcpsCourseListData?.success]);

  const handleMainTrainingOption = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const mainTraining = mainTrainings?.find(
      (mainTraining) => mainTraining.id === value,
    );
    setMainTraining(mainTraining!);
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.main_training = mainTraining?.id;
    newQueryParams.course_type = '';
    setQueryParams(newQueryParams);
    setForms([]);

    if (value === '') {
      setCoreAdvanceOptions([]);
    } else {
      setCoreAdvanceOptions([
        { label: 'Core', value: 'core' },
        { label: 'Specialty', value: 'adv' },
      ]);
    }
  };

  const handleCoreAdvance = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    values.course_type = value;
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.course_type = value;
    setQueryParams(newQueryParams);

    if (value === '') {
      setForms([]);
    } else {
      setForms(formSetups?.data!);
    }
  };

  useEffect(() => {
    const subject = subjects?.find((subject) => subject.id === selectedSubject?.value);
    setSubject(subject!);

    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.subject_id = subject?.id;
    newQueryParams.main_training = '';
    newQueryParams.course_type = '';
    setQueryParams(newQueryParams);
    setCoreAdvanceOptions([]);
    setForms([]);

    setMainTraining({ id: '' } as FcpsCourseList);
    if (selectedSubject?.value === '') {
      setMainTrainings([]);
    }
  }, [selectedSubject]);


  useEffect(() => {
    if (
      queryParams.subject_id &&
      queryParams.main_training &&
      queryParams.course_type &&
      selectedType
    ) {
      const updatedParams = { ...queryParams, id: selectedType?.value };
      getForms(updatedParams);
    }
  }, [queryParams, selectedType]);


  useEffect(() => {
    if (formSetups && isFormSetupsSuccess) {
      setForms(formSetups?.data);
    }
  }, [formSetups, isFormSetupsSuccess]);

  const handleFormSelect = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const form = forms.find((form) => form.id === value);
    setSelectedForm(form || null);

    setSelectedCaseType('');

    console.log(form);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <div className='page-breadcrumb-wrapper'>
          <BetterBreadcrumb
            title={'Logbook Entry Setup Master List'}
            breadcrumbItem={[{ link: '#', name: 'Add Logbook Entry Setup Master' }]}
          />
          <div>
            <Button color="primary" onClick={() => history.push('/setup/add-logbook-entry-setup-master')}>
              Add Logbook Entry Setup Master
            </Button>
          </div>
        </div>
        <Card>
          <CardBody>
            <Form
              className='filter-wrapper'
              onSubmit={(e) => {
                e.preventDefault();
                // handleSubmit();
              }}
              onReset={(e) => {
                // e.preventDefault();
                // handleSubmit();
                resetForm();
                setQueryParams({});
                setSelectedForm(null);
                setSelectedSubject(null);
                setSelectedType(null);
                setCoreAdvanceOptions([]);
                setForms([]);
                getForms({
                  id: 1,
                  subject_id: '',
                  main_training: '',
                  course_type: '',
                });
              }}
            >
              <FormGroup className="mb-3 extent-field">
                <Label className="form-label">Type</Label>
                <Select
                  isClearable={true}
                  isSearchable={true}
                  value={selectedType}
                  onChange={setSelectedType}
                  options={typeOptions}
                  placeholder="Select Type"
                  name="type"
                  id="type"
                />
              </FormGroup>


              <FormGroup className="mb-3 extent-field">
                <Label className="form-label">Subject</Label>
                <Select
                  isClearable={true}
                  isSearchable={true}
                  value={selectedSubject}
                  onChange={setSelectedSubject}
                  options={subjectOptions}
                  placeholder="Select Subject"
                  name="subject"
                  id="subject"
                />
              </FormGroup>

              <FormGroup className="mb-3 extent-field">
                <Label className="form-label">Main Training</Label>
                <InputField
                  type="select"
                  name="mainTraining"
                  placeholder=""
                  value={mainTraining?.id}
                  options={mainTrainingOptions}
                  onChange={(e) => {
                    handleMainTrainingOption(e);
                  }}
                />
              </FormGroup>

              <FormGroup className="mb-3 extent-field">
                <Label className="form-label">Core/Speciality</Label>
                <InputField
                  type="select"
                  name="course_type"
                  placeholder=""
                  options={coreAdvanceOptions}
                  onChange={(e) => {
                    handleCoreAdvance(e);
                  }}
                />
              </FormGroup>

              <FormGroup className="mb-3 extent-field">
                <Label className="form-label">Form</Label>
                <InputField
                  type="select"
                  name="setup_logbook_master_id"
                  placeholder=""
                  value={selectedForm?.id}
                  options={formOptions}
                  onChange={(e) => {
                    handleFormSelect(e);
                  }}
                  invalid={{ errors, touched }}
                />
              </FormGroup>

              <FormGroup className='btn-column mb-3'>
                <Button color='warning' type='reset' outline>Reset</Button>
                {/* <Button type='submit' color='primary'>Search</Button> */}
              </FormGroup>

            </Form>

            <DataTable
              columns={columns}
              data={data?.data || []}
              pagination
              paginationServer
              // progressPending={isLoading}
              expandOnRowClicked
              // highlightOnHover
              // paginationTotalRows={entryList?.total}
              // onChangePage={handlePageChange}
              // onChangeRowsPerPage={handlePerRowsChange}
              paginationRowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
              responsive
              persistTableHead={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};
